namespace advisorop.components.advisor {

    export class CuAccountController {

        // input params
        account: domains.IAccount = { id: 0, manualAccount: {}, investors: [] };
        createNewCustodianAccount: boolean = false;
        investorsDirty: boolean = false;
        advisoryFirm: domains.IAdvisoryFirm;
        iAmReady: any;

        // dropdowns
        advisoryFirms: Array<domains.IAdvisoryFirm> = [];
        householdGroups: domains.IHousehold[] = [];
        lovs: Array<domains.ILOV> = [];
        titleTypes: Array<domains.ILOV> = [];
        titleSubtypes: Array<domains.ILOV> = [];
        accountTypes: Array<domains.ILOV> = [];
        tamps: domains.ITamp[] = [];
        productTypes: domains.ILOV[] = [];
        managers: domains.IManager[] = [];
        products: domains.IManagerProduct[] = [];
        insuranceTypes: Array<domains.ILOV> = [];
        insuranceSubtypes: Array<domains.ILOV> = [];
        premiumModels: Array<domains.ILOV> = [];
        generalInvestmentAccountTypes: Array<domains.ILOV> = [];
        states: Array<domains.ILOV> = [];

        selTitleType: domains.ILOV;
        selTitleSubtype: domains.ILOV;
        selAccountType: domains.ILOV;
        selTamp: domains.ITamp;
        selProductType: domains.ILOV;
        selManager: domains.IManager;
        selProduct: domains.IManagerProduct;
        selHouseholdGroup: domains.IHousehold;
        selAdvisoryFirm: domains.IAdvisoryFirm;
        selPremiumModel: domains.ILOV;
        selPolicyType: domains.ILOV;
        selPolicySubtype: domains.ILOV;
        selGeneralInvestmentAccountType: domains.ILOV;
        selState: domains.ILOV;
        
        companyGroup: domains.ICompanyGroup;
        currentAdvisor: domains.IAdvisor;

        //insuranceType: number = domains.ManualAccountHoldingType.INSURANCE;
        hasInsuranceSubtypes: boolean = false;


        loveTypeOfSubtypes: number;

        showGeneralAccountTypeField: boolean = false;
        showStateField: boolean = false;

        hasRtgHoldings: boolean = false;

        investorType: domains.InvestorType = null;
        entityType: domains.EntityType = null;

        // types 
        accountType = domains.InvestmentType;
        productType = domains.ProductType;
        titleType = domains.TitleType;

        static $inject = ["generalService", "advisorService", "identityService", "advisoryFirmApi", "$scope"];
        constructor(private generalService: services.GeneralService,
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private $scope: ng.IScope) {

            // watch TitleType and TitleSubType
            $scope.$watchGroup(["vm.account.titleType", "vm.account.titleSubtype", "vm.selTitleType.value", "vm.selTitleSubtype.value"],
                (newval: any, oldval: any, scope: ng.IScope) => this.setInvestorsDomain());

            $scope.$watch("vm.account.id", () => {
                if (this.account.id > 0) {
                    this.bindAccountForm();
                }
            });
        }

        // /////////////////////////////////////
        // account methods
        setInvestorsDomain(): void {
            if (!this.selTitleType)
                return;

            // Nov 2018 GL : commented this out, not sure why 401k specifically was looking for companies,
            // think it can follow the other types and use the same ".extra1" attribute from the LOV entry.
            //if (this.selTitleType.value == domains.TitleType.OTHER_RETIREMENT && this.selTitleSubtype && this.selTitleSubtype.value == domains.TitleSubtype.I401_K) {
            //    if (this.investorType != domains.InvestorType.INDIVIDUAL) {
            //        this.account.investors = [];
            //        this.investorsDirty = true;
            //    }
            //    this.investorType = domains.InvestorType.COMPANY;
            //    this.entityType = null;

                // Entities
            //} else

            if(this.selTitleType.extra1 == "1") {
                if (this.investorType != domains.InvestorType.COMPANY && this.entityType != <domains.EntityType>this.selTitleType.value) {
                    this.account.investors = [];
                    this.investorsDirty = true;
                }
                this.investorType = domains.InvestorType.COMPANY;
                this.entityType = <domains.EntityType>this.selTitleType.value;
                // Individuals
            } else if (this.selTitleType.extra1 == "0") {
                if (this.investorType != domains.InvestorType.INDIVIDUAL) {
                    this.account.investors = [];
                    this.investorsDirty = true;
                }
                this.investorType = domains.InvestorType.INDIVIDUAL;
                this.entityType = null;
                //Can be both
            } else {
                this.investorType = null;
                this.entityType = null;
            }
        }

        removeInvestor(inv: domains.IInvestor): void {
            var ind = this.account.investors.indexOf(inv);
            if (ind >= 0) {
                this.account.investors.splice(ind, 1);
                this.loadHouseholdGroups();
                this.investorsDirty = true;
            }
        };

        resetFormFields(): void {
            this.account.manualAccount = {};
        }

        validateAccountBasicInformationForm(): boolean {
            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["accountForm"]);

            if (this.account.investors.length <= 0) {
                formIsValid = false;
                toastr.error("You must select one or more investors.");
            }

            if (!formIsValid)
                toastr.error("Account application is not complete. Please correct errors and try again.");

            return formIsValid;
        };

        // ////////////////////////////////
        // on change methods
        advisoryFirmChanged(): void {
            
            if (this.selAdvisoryFirm) {

                //console.log(`Advisory firm changed to ${this.selAdvisoryFirm.advisoryFirmName}`);

                this.account.advisoryFirmId = this.selAdvisoryFirm.id;
                
                this.loadTamps(this.account.advisoryFirmId);

                this.loadManagers();
                this.loadProducts();
            }
            else {
                this.account.advisoryFirmId = null;
            }
        }

        productTypeChanged(): void {

            this.showGeneralAccountTypeField = this.selProductType && (this.selProductType.value === domains.ProductType.GENERAL_INVESTMENT);
            this.showStateField = this.selProductType && this.selProductType.value === domains.ProductType.P_529;

            if (this.selProductType) {

                if (this.selProductType.value == domains.ProductType.GENERAL_INVESTMENT) {
                    this.loadGeneralInvestmentAccountTypes();
                    // default value
                    if (!this.selGeneralInvestmentAccountType) {
                        this.selGeneralInvestmentAccountType = this.generalInvestmentAccountTypes.filter(v => v.value == domains.GeneralInvestmentAccountType.INVESTMENT_ACCOUNT)[0];
                        this.generalInvestmentAccountTypeChanged();
                    }
                } else if (this.isInsuranceProduct() && this.account.manualAccount) {
                    this.selPremiumModel = this.premiumModels.filter(v => v.value == this.account.manualAccount.premiumMode)[0];
                    this.loadInsuranceTypes();
                    this.selPolicyType = this.insuranceTypes.filter(v => v.value == this.account.manualAccount.policyInsuranceType)[0];
                    this.loadInsuranceSubtypes();
                    this.selPolicySubtype = this.insuranceSubtypes.filter(v => v.value == this.account.manualAccount.policyInsuranceSubtype)[0];
                }
                // reload managers and products
                this.loadManagers();
                this.loadProducts();
            }
        };

        titleTypeChanged(changedByUserOnUI: boolean = false): void {

            if (changedByUserOnUI)
                this.account.investors = [];

            if (this.selTitleType && this.selTitleType.value >= 0) {
                this.loadTitleSubtypes();
                if (this.titleSubtypes.length > 0) {
                    this.selTitleSubtype = this.titleSubtypes[0];
                } else {
                    this.selTitleSubtype = null;
                }
            }
        };

        accountTypeChanged(): void {
            this.selTamp = null;
            this.selProductType = null;
            this.productTypeChanged();
            if (this.selAccountType) {
                this.account.accountType = this.selAccountType.value;
                if (this.isOutsideInvestmentAccount()) {
                    this.loadHouseholdGroups().then(
                        response => {
                            if (this.account.tempHouseholdGroup > 0) {
                                let tmp = this.householdGroups.filter(v => v.id == this.account.tempHouseholdGroup);
                                if (tmp && tmp.length > 0) {
                                    this.selHouseholdGroup = tmp[0];
                                }
                            }
                        }
                    );
                }
                else if (this.isDirectInvestmentAccount()) {
                    this.loadAdvisoryFee();
                    this.selHouseholdGroup = null;
                }
                else {
                    this.selHouseholdGroup = null;
                };
            }
            else {
                this.account.accountType = null;
            }
        };

        managerChanged(): void {
            this.loadProducts();
        }

        productChanged(): void {
            if (this.account.accountType === domains.InvestmentType.DIRECT_INVESTMENT) {
                this.loadAdvisoryFee();
            }
        }

        policyTypeChanged(): void {
            this.loadInsuranceSubtypes();
            if (this.selPolicyType) {
                if (this.account.manualAccount)
                    this.account.manualAccount.policyInsuranceType = this.selPolicyType.value;
                if (this.insuranceSubtypes.length > 0) {
                    this.hasInsuranceSubtypes = true;
                    this.selPolicySubtype = this.insuranceSubtypes[0];
                }
                else
                    this.selPolicySubtype = null;
            }
            else {
                this.selPolicySubtype = null;
            }
            this.policySubtypeChanged();
        };

        policySubtypeChanged(): void {
            if (this.account.manualAccount) {
                if (this.selPolicySubtype)
                    this.account.manualAccount.policyInsuranceSubtype = this.selPolicySubtype.value;
                else
                    this.account.manualAccount.policyInsuranceSubtype = null;
            }
        }

        generalInvestmentAccountTypeChanged(): void {
            if (this.selGeneralInvestmentAccountType && this.account.manualAccount) {
                this.account.manualAccount.generalInvestmentAccountType = this.selGeneralInvestmentAccountType.value;
            }
            //console.log("CHANGED this.account.manualAccount.generalInvestmentAccountType", this.account.manualAccount.generalInvestmentAccountType)
        }

        premiumModelChanged(): void {
            if (this.account.manualAccount) {
                if (this.selPremiumModel) {
                    this.account.manualAccount.premiumMode = this.selPremiumModel.value;
                }
                else {
                    this.account.manualAccount.premiumMode = 0;
                }
            }
        };

        // ///////////////////////////////
        // load methods
        bindAccountFromForm() {

            //console.log("Binding account from form...");

            this.account.advisoryFirm = this.selAdvisoryFirm;

            // title type and subtype
            if (this.selTitleType) {
                this.account.titleType = this.selTitleType.value;
                this.account.titleTypeDescription = this.selTitleType.name;
                if (this.selTitleSubtype) {
                    this.account.titleSubtype = this.selTitleSubtype.value;
                    this.account.titleSubtypeDescription = this.selTitleSubtype.name;
                }
                else {
                    this.account.titleSubtype = null;
                    this.account.titleSubtypeDescription = "";
                }
            }
            else {
                this.account.titleType = null;
                this.account.titleTypeDescription = "";
                this.account.titleSubtype = null;
                this.account.titleSubtypeDescription = "";
            }

            if (this.selAccountType) {
                this.account.accountType = this.selAccountType.value;
            }
            else {
                this.account.accountType = null;
            }
            
            if (this.selTamp && this.hasTamp()) {
                this.account.tampId = this.selTamp.id;
                this.account.tampType = this.selTamp.type;
                this.account.tampName = this.selTamp.name;
            }
            else {
                this.account.tampId = null;
            }

            if (this.selProductType && this.hasProductType()) {
                this.account.productTypeId = this.selProductType.value;
            }
            else {
                this.account.productTypeId = null;
            }

            // manager / company
            if (this.selManager && this.hasProductType()) {
                this.account.managerId = this.selManager.id;
            }
            else {
                this.account.managerId = null;
            }

            // product
            if (this.selProduct && this.hasProductType()) {
                this.account.productId = this.selProduct.id;
            }
            else {
                this.account.productId = null;
            }

            if (this.account.manualAccount) {
                if (this.selProductType && this.selProductType.value === domains.ProductType.GENERAL_INVESTMENT && this.selGeneralInvestmentAccountType) {
                    this.account.manualAccount.generalInvestmentAccountType = this.selGeneralInvestmentAccountType.value;
                }
                else {
                    this.account.manualAccount.generalInvestmentAccountType = null;
                }
                //console.log("this.account.manualAccount.generalInvestmentAccountType", this.account.manualAccount.generalInvestmentAccountType)
            }

            if (this.selHouseholdGroup) {
                this.account.tempHouseholdGroup = this.selHouseholdGroup.id;
            }
            else {
                this.account.tempHouseholdGroup = null;
            }
        }

        fromAccount: domains.IAccount

        bindAccountForm() {

            var ctrl = this;

            //console.log("Binding account form: ", this.account);

            this.selAdvisoryFirm = <domains.IAdvisoryFirm>{ id: this.account.advisoryFirmId };
            this.loadAdvisoryFirms().then(response => {
                this.selAdvisoryFirm = response.filter(v => v.id == this.account.advisoryFirmId)[0];
            });

            // account title and subtitle
            this.selTitleType = <domains.ILOV>{ value: this.account.titleType };// this.titleTypes.filter(v => v.value == this.account.titleType)[0];
            this.titleTypeChanged();
            this.selTitleSubtype = <domains.ILOV>{ value: this.account.titleSubtype };

            // investment type 
            this.selAccountType = <domains.ILOV>{ value: this.account.accountType };//this.accountTypes.filter(v => v.value == this.account.accountType)[0];

            // tamp
            if (this.account.tampId && this.account.tampId > 0) {
                this.loadTamps(this.account.advisoryFirmId)
                    .then(() => this.selTamp = this.tamps.filter(v => v.id == this.account.tampId)[0]);
            }

            // product type 
            this.selProductType = null;
            if (this.account.productTypeId && this.account.productTypeId > 0) {
                this.selProductType = this.productTypes.filter(v => v.value == this.account.productTypeId)[0];
            }
            this.productTypeChanged();

            // manager and manager product
            this.selManager = <domains.IManager>{ id: this.account.managerId };
            this.selProduct = <domains.IManagerProduct>{ id: this.account.productId };
            let me = this;
            if (this.account.managerId && this.account.managerId > 0) {
                me.loadManagers()
                    .then(() => {
                        this.selManager = this.managers.filter(f => f.id === this.account.managerId)[0];
                        this.managerChanged();
                    });
            }

            // HHG
            if (this.account.tempHouseholdGroup && this.account.tempHouseholdGroup > 0) {
                this.loadHouseholdGroups()
                    .then(() => this.selHouseholdGroup = this.householdGroups.filter(v => v.id == this.account.tempHouseholdGroup)[0]);
            }
        };

        bindAccountForm2(fromAccount: domains.IAccount) {
            this.account = fromAccount;
            this.bindAccountForm();
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {

                    this.lovs = data;

                    this.loadInsuranceTypes();

                    this.generalInvestmentAccountTypes = this.lovs.filter(v => v.lovType == domains.LovType.GENERAL_INVESTMENT_ACCOUNT_TYPES);

                    this.titleTypes = this.lovs.filter(v => v.lovType == domains.LovType.TITLE_TYPE);

                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE && !v.extra2);

                    this.premiumModels = this.lovs.filter(v => v.lovType == domains.LovType.PREMIUM_MODE);

                    this.productTypes = this.lovs.filter(f => (f.lovType == domains.LovType.PRODUCT_TYPE));

                    this.states = this.lovs.filter((value, index, array) => { return value.lovType == domains.LovType.STATES });

                }, err => this.generalService.showError(err));
        };

        loadInsuranceTypes(): void {
            if (this.selProductType) this.insuranceTypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_TYPE && v.parentId == this.selProductType.value);
            else this.insuranceTypes = [];
        };

        loadInsuranceSubtypes(): void {
            if (this.selPolicyType) this.insuranceSubtypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_SUBTYPE && v.parentId == this.selPolicyType.value);
            else this.insuranceSubtypes = [];
        };

        loadGeneralInvestmentAccountTypes() {
            this.generalInvestmentAccountTypes = this.lovs.filter(v => v.lovType == domains.LovType.GENERAL_INVESTMENT_ACCOUNT_TYPES);
        }

        loadHouseholdGroups(): ng.IPromise<domains.IAccountGroup[]> {
            let investors = this.account.investors.map(m => m.id);
            return this.advisorService.getHouseholdGroupsByInvestors(investors)
                .then(response => this.householdGroups = response.data,
                    err => console.log(`Household groups could not be loaded. Error ${err.status}: ${err.data}`));
        }

        loadAdvisoryFirms(): ng.IPromise<domains.IAdvisoryFirm[]> {
            return this.advisoryFirmApi.getAdvisoryFirms()
                .then(data => this.advisoryFirms = data.data, err => this.generalService.showError(err));
        };
        
        loadTitleSubtypes(): void {
            if (this.selTitleType) {
                this.titleSubtypes = this.lovs.filter(v => v.lovType == domains.LovType.TITLE_SUBTYPE && v.parentId == this.selTitleType.value);
            } else {
                this.titleSubtypes = [];
            }
        };

        loadTamps(advisoryFirmId: number): ng.IPromise<domains.ITamp[]> {
            return this.advisoryFirmApi.getTamps(advisoryFirmId)
                .then(response => {
                    this.tamps = response.data;
                    // by default first TAMP is selected - PERSHING
                    if (!this.selTamp && this.tamps.length > 0) {
                        this.selTamp = this.tamps[0];
                    }
                    return response.data;
                }, err => this.generalService.showError(err));
        };

        loadManagers(): ng.IPromise<any> {
            if (this.selProductType) {
                // outside investment account should show global Managers and Products for selected product type and manager
                if (this.account.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                    return this.advisorService.getAllManagers(this.selProductType.value)
                        .then(response => {
                            this.managers = response.data;
                            //console.log("Managers loaded", this.managers);
                            return response;
                        }, err => this.generalService.showError(err));
                }
                else if (this.selAdvisoryFirm && this.account.accountType == domains.InvestmentType.DIRECT_INVESTMENT) {
                    return this.advisorService.getManagers(this.selAdvisoryFirm.id, this.selProductType.value)
                        .then(response => {
                            this.managers = response.data;
                            //console.log("Managers loaded", this.managers);
                            return response;
                        }, err => this.generalService.showError(err));
                }
                else {
                    console.log("Missing account type or advisory firm!", this.selAdvisoryFirm, this.account.accountType);
                }
            }
            else
                console.log("Missing product type!");

            // else reset manager list
            this.selManager = null;
            this.managers = [];
        };

        loadProducts(): ng.IPromise<any> {
            if (this.selManager && this.selProductType) {
                // outside investment account should show global Managers and Products for selected product type and manager
                if (this.account.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                    return this.advisorService.getProductsByManager(this.selProductType.value, this.selManager.id)
                        .then(response => {
                            this.products = response.data;
                            //console.log("Products loaded", this.products);
                        }, err => this.generalService.showError(err));
                }
                // direct investment account should show advisory firm Managers and Products for selected product type and manager
                else if (this.account.accountType == domains.InvestmentType.DIRECT_INVESTMENT && this.selAdvisoryFirm) {
                    return this.advisorService
                        .getProductsByFirm(this.selAdvisoryFirm.id, this.selProductType.value, this.selManager.id, domains.InvestmentType.DIRECT_INVESTMENT)
                        .then(response => {
                            this.products = response.data;
                            //console.log("Products loaded", this.products);
                        }, err => this.generalService.showError(err));
                }
            }

            // else reset product list
            this.selProduct = null;
            this.products = [];
        };

        loadAdvisoryFee() {
            let feeOnProduct = false;

            // take fee from product
            if (this.selProduct && this.products.length > 0) {
                this.products.filter(product => product.id === this.selProduct.id)[0].firmProducts.forEach(firmProduct => {
                    if (firmProduct.advisoryFee) {
                        this.account.advisoryFee = firmProduct.advisoryFee;
                        feeOnProduct = true;
                        return;
                    }
                });
            }

            //take default advisoryFirm fee
            if (!feeOnProduct && this.selAdvisoryFirm) {
                this.advisoryFirms.forEach(firm => {
                    if (firm.id === this.selAdvisoryFirm.id) {
                        this.account.advisoryFee = firm.defaultAdvisoryFee;
                        return;
                    }
                });
            }
        }

        firstInvestorAdded: boolean = false;
        // ///////////////////////////////////////
        // events from other components handling
        newInvestorSelected(investor: domains.IInvestor): void {
            var inv = this.account.investors.filter(v => v.id == investor.id);
            if (inv.length === 0) {

                if (!this.selTitleType) {
                    toastr.warning("Please select account type.");
                    return;
                }

                if (this.isMultiInvestorAccount()) {
                    this.addInvestorToInvestors(investor);
                    return;
                }

                if (this.isCustodialAccount()) {
                    this.addInvestorToInvestors(investor);
                    return;
                }

                if (!this.isMultiInvestorAccount(true) && !this.isCustodialAccount(true)) {
                    if (this.account.investors.length < 1) {
                        this.addInvestorToInvestors(investor);
                        return;
                    }
                    else {
                        toastr.warning("Cannot add more than one investor for this title type.");
                        return;
                    }
                }
                else {
                    return;
                }
            }
            else
                toastr.warning("Investor already exists on the list of investors for this account.");
        };

        changedMinorInvestor(investor: domains.IInvestor): void {
            for (let i = 0; i < this.account.investors.length; i++)
                this.account.investors[i].minorInvestor = false;

            var index = this.account.investors.indexOf(investor);

            let inv = this.account.investors[index];

            inv.minorInvestor = true;
        }

        changedPrimaryInvestor(investor: domains.IInvestor): void {
            for (let i = 0; i < this.account.investors.length; i++)
                this.account.investors[i].primaryInvestor = false;
                
            var index = this.account.investors.indexOf(investor);

            let inv = this.account.investors[index];
            
            inv.primaryInvestor = true;
        }

        //printInvestors(): void {
        //    for (let i = 0; i < this.account.investors.length; i++) {
        //        console.log("Investor: " + i + " ", this.account.investors[i]);
        //    }
        //}

        addInvestorToInvestors(investor: domains.IInvestor): void {
            if (this.account.investors.length == 0 && this.isMultiInvestorAccount(true))
                investor.primaryInvestor = true;

            if (this.account.investors.length == 1 && this.isCustodialAccount(true))
                investor.minorInvestor = true;

            this.account.investors.push(investor);
            this.firstInvestorAdded = true;
            this.loadHouseholdGroups();
            this.investorsDirty = true;
        }

        isMultiInvestorAccount(flag: boolean = false): boolean {
            if (!flag) {
                if (this.selTitleType.value == domains.TitleType.JOINT_TENANT.valueOf()
                    || this.selTitleType.value == domains.TitleType.JOINT_TRANSFER_ON_DEATH.valueOf()
                    || this.selTitleType.value == domains.TitleType.TRUST.valueOf()
                    || this.selTitleType.value == domains.TitleType.ESTATE.valueOf()) {

                    if (this.account.investors.length == 6) {
                        toastr.warning("The maximum number of investors for this title type is six.");
                        return false;
                    }
                    else {
                        //toastr.warning("Please add at least two investors for this title type.");
                        return true;
                    }
                }
                else {
                    return false;
                }
            } else {
                if (this.selTitleType.value == domains.TitleType.JOINT_TENANT.valueOf() || this.selTitleType.value == domains.TitleType.JOINT_TRANSFER_ON_DEATH.valueOf())
                    return true;
                return false;
            }
        }

        isCustodialAccount(flag: boolean = false): boolean {
            if (!flag) {
                if (this.selTitleType.value === domains.TitleType.CUSTODIAL) {
                    if (this.account.investors.length < 2) {
                        return true;
                    }
                    else {
                        toastr.warning("Cannot add more then two investors for this title type.");
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                if (this.selTitleType.value === domains.TitleType.CUSTODIAL)
                    return true;
                return false;
            }
        }


        // ///////////////////////////////////
        // dynamic properties
        showTempHH(): boolean {
            return (this.isOutsideInvestmentAccount() || (this.isDirectInvestmentAccount() && this.isInsuranceProduct()));
        };

        hasProposal(): boolean {
            // proposal is used for Managed Investments and Individual Holdings
            return (
                (this.account.id > 0 &&
                    (this.account.accountType == domains.InvestmentType.MANAGED_MODELS
                        || this.selAccountType.value == domains.InvestmentType.SMA
                        || this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS))
                ||
                (this.selAccountType &&
                    (this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS
                        || this.selAccountType.value == domains.InvestmentType.SMA
                        || this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS)));
        }

        hasSubscriptionAgreement(): boolean {
            // subscription document is used for Direct Investments
            var ret = (
                (this.account && (this.account.id > 0) && (this.account.accountType == domains.InvestmentType.DIRECT_INVESTMENT))
                ||
                (this.selAccountType && (this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT))
            );
            return ret;
        }

        //hasCustodian(): boolean {
        //    return this.selAccountType &&
        //        (this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS
        //            || this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS);
        //}

        isCustodianOptional(): boolean {
            return this.selAccountType && this.selProductType
                && this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT
                && (this.selProductType.value == domains.ProductType.GENERAL_INVESTMENT
                    || (this.selProductType.value == domains.ProductType.REIT
                        // 
                        // && this.selTitleType 
                        // && (this.selTitleType.value == domains.TitleType.IRA || this.selTitleType.value == domains.TitleType.OTHER_RETIREMENT)
                    )
                );
        }

        isCustodianRequired(): boolean {

            return (
                    (this.selAccountType &&
                        (this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS ||
                        this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS ||
                        this.selAccountType.value == domains.InvestmentType.SMA)
                    ) ||
                (this.selAccountType && this.selProductType
                    && this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT
                    && this.selProductType.value == domains.ProductType.REIT
                    && this.selTitleType
                    && (this.selTitleType.value == domains.TitleType.IRA || this.selTitleType.value == domains.TitleType.OTHER_RETIREMENT)
                )
            );
        }

        hasTamp(): boolean {
            let v = this.selAccountType &&
                (this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS || this.selAccountType.value == domains.InvestmentType.SMA);

            if (v && !this.selTamp && this.tamps && this.tamps.length > 0)
                this.selTamp = this.tamps[0];

            return v;
        };

        hasProductType(): boolean {
            return this.selAccountType &&
                (this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT || this.selAccountType.value == domains.InvestmentType.OUTSIDE_INVESTMENT);
        };

        isOutsideInvestmentAccount(): boolean {
            return (this.selAccountType && this.selAccountType.value == domains.InvestmentType.OUTSIDE_INVESTMENT);
        }

        isDirectInvestmentAccount(): boolean {
            return (this.selAccountType && this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT);
        }

        isInsuranceProduct(): boolean {
            return this.selProductType && (this.selProductType.value === domains.ProductType.LIFE_INSURANCE ||
                this.selProductType.value === domains.ProductType.OTHER_INSURANCE);
        }
        isAnnuityProduct(): boolean {
            return this.selProductType && (this.selProductType.value === domains.ProductType.ANNUITY);
        }
        isOtherProduct(): boolean {
            return this.selProductType
                && (this.selProductType.value !== domains.ProductType.ANNUITY)
                && (this.selProductType.value !== domains.ProductType.LIFE_INSURANCE)
                && (this.selProductType.value !== domains.ProductType.OTHER_INSURANCE);
        }
        isBrokerDealerFirm(): boolean {
            return this.selAdvisoryFirm.firmType == domains.FirmType.BROKER_DEALER;
        }
        
        // overrides ...
        $onInit(): void {
            //this.loadAdvisoryFirms();
            this.loadAdvisoryFirms().then(response => {
                // default advisory firm to first in list if we are not already working with an account
                if (this.account.id == 0 && this.account.advisoryFirmId == undefined) {
                    this.selAdvisoryFirm = response[0];
                    this.advisoryFirmChanged();
                }
            });
            this.identityService.getUserPromise().then(response => {
                this.currentAdvisor = response.advisor;
                this.companyGroup = response.advisor.companyGroup;
            });
            this.loadLovs();
            this.iAmReady({ ctrl: this });
        };

        $onChanges(event): void {
            //console.log("CuAccount: onChanges fired", event, this.advisoryFirm);
            //console.log("Acount on changes: ", this.account);
            for (var key in event) {
                if (key === "advisoryFirm") {
                   // console.log(`Binding advisory firm`, this.advisoryFirm);
                    if (this.advisoryFirm) {
                        this.account.advisoryFirm = this.advisoryFirm;
                        this.account.advisoryFirmId = this.advisoryFirm.id;
                        this.selAdvisoryFirm = this.advisoryFirm;
                        this.loadTamps(this.advisoryFirm.id);
                    }
                }
            }
        }

    }

    class CuAccount implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                account: "=",
                iAmReady: "&",
                advisoryFirm: "<"
            };
            this.controller = CuAccountController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/cu-account.html";
        }
    }
    angular.module(Constants.APP).component("cuAccount", new CuAccount());
}